import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { Breadcrumbs, Typography, Link, Stack, TablePagination } from "@mui/material";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { useMemo } from "react";
import { Link as LinkTo } from 'react-router';
import { BackButton } from "../../../../../common/components/back_button";

import DynamicIcon from "../../../../../common/components/dynamic_icon";
import PrimaryButton from "../../../../../common/components/primary_button";
import AlertError from "../../../../../common/components/alert_error";
import RefreshButton from "../../../../../common/components/refresh_button";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { GenerateChecklistMaquinaEquipItensCadastroColumnDefinition } from "./columns";
import { useChecklistMaquinaEquipItensCadastroViewModel } from "../../viewModels/checklist_maquina_equip_itens_cadastro_view_model";
import { ChecklistMaquinaEquipItemModel } from "../../../domain/models/checklist_maquina_equip_item";
import { ItemChecklistMaquinaEquipModal } from "./components/item_checklist_maquina_equip_modal";

/**
 * ChecklistServicoItensCadastro
 */

export const ChecklistMaquinaEquipItensCadastro = () => {
  const viewModel = useChecklistMaquinaEquipItensCadastroViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateChecklistMaquinaEquipItensCadastroColumnDefinition({
      hasObraChecklistMaquinaEquip: true,
      onActionEditar: viewModel.handleItemChecklistMaquinaEquipModalOpenState,
      onActionDeletar: viewModel.handleItemChecklistMaquinaEquipDeleteModalOpenState,
    });
  }, [
    viewModel.handleItemChecklistMaquinaEquipModalOpenState,
    viewModel.handleItemChecklistMaquinaEquipDeleteModalOpenState,
  ]);

  return (
    <>
      {/**
        * PageTopBar
        */}

      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              {
                <div className="w-[200px] ">
                  <PrimaryButton
                    buttonColor="red"
                    startIcon={<DynamicIcon nameIcon="Delete" size={25} className="text-white" />}
                    onMouseDown={_ => { }}>
                    Excluir Selecionados
                  </PrimaryButton>
                </div>
              }
              {
                <div className="w-[115px] ">
                  <PrimaryButton
                    startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                    onMouseDown={_ => viewModel.handleItemChecklistMaquinaEquipModalOpenState(null, true)}>
                    Novo Item
                  </PrimaryButton>
                </div>
              }

              <BackButton
                onClick={viewModel.handleBack}
              />
            </div>
          }
        />
      </PageTopBar>

      {/**
        * Page
        */}

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Obras
          </Link>
          <Link underline="hover" color="inherit" component={'span'}>
            <LinkTo to={`/ChecklistMaquinaEquip_lista`}>Checklist de Máquina/Equipamento</LinkTo>
          </Link>
          <Typography className="text-primary-green">
            Itens do Checklist de Máquina/Equipamento
          </Typography>
        </Breadcrumbs>

        <div className="flex flex-col gap-2">
          <div className="div flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
            <div className="flex gap-2 items-center w-full">
              <h1 className="text-3xl font-medium text-black dark:text-white">Itens do Checklist de Máquina/Equipamento</h1>
              <RefreshButton onClick={viewModel.handleReload} />
            </div>

            <div className="w-full justify-end flex gap-2">
            </div>
          </div>

          {
            viewModel.checklistMaquinaEquip &&
            <div className="w-full flex flex-col gap-0">
              <div className="w-full flex flex-row items-center">
                <span className="text-black dark:text-white font-bold text-lg">
                  {viewModel.checklistMaquinaEquip.codigo} | {viewModel.checklistMaquinaEquip.descricao}
                </span>
              </div>
              {
                (viewModel.checklistMaquinaEquip.revisao && viewModel.checklistMaquinaEquip.revisao.length > 0) &&
                <span className="text-gray-600 dark:text-gray-300 font-bold text-base">
                  Revisão: {viewModel.checklistMaquinaEquip.revisao}
                </span>
              }
              {/* {
                viewModel.checklistMaquinaEquip.hasObraChecklistMaquinaEquip &&
                <div className="w-full mt-4">
                  <Alert severity="error">
                    Não é possível incluir ou excluir itens do check list, pois ele está vinculado à alguma obra.
                  </Alert>
                </div>
              } */}
            </div>
          }
        </div>
        {
          viewModel.errorMessage !== undefined
            ? (
              <div className="w-full">
                <AlertError
                  messageErro={viewModel.errorMessage}
                  onTryAgain={viewModel.handleReload} />
              </div>
            ) : (
              <>
                <Stack spacing={0}>
                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                  <StyledDataGrid
                    tableName="checklist_maquina_equip_itens_cadastro"
                    disableColumnMenu={false}
                    checkboxSelection={false}
                    rowSelectionModel={viewModel.rowSelectionModel}
                    getRowId={(row: ChecklistMaquinaEquipItemModel) => row.idItemChecklistMaquinaEquip}
                    getRowHeight={() => 'auto'}
                    textSize="pequeno"
                    columns={columnsDefinition}
                    loading={viewModel.loading}
                    rows={viewModel.listaChecklistMaquinaEquipItens ?? []}
                    rowCount={viewModel.listaChecklistMaquinaEquipItens?.length ?? 0}
                    pageSizeOptions={[10, 25, 50, 100]}
                    paginationMode="server"
                    paginationModel={{
                      page: viewModel.pagination.page,
                      pageSize: viewModel.pagination.rowsPerPage,
                    }}
                    onRowSelectionModelChange={viewModel.handleRowSelectionModelChange}
                  />

                  <TablePagination
                    component="div"
                    count={viewModel.pagination.totalItems}
                    page={viewModel.pagination.page - 1}
                    onPageChange={(_, p) => viewModel.handlePageChange(p)}
                    rowsPerPageOptions={[10, 25, 50, 100]}
                    rowsPerPage={viewModel.pagination.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleRowsPerPageChange(parseInt(e.target.value))}
                  />

                </Stack>
              </>
            )
        }
      </div>

      {/**
        * Modals
        */}

      <ItemChecklistMaquinaEquipModal
        open={viewModel.itemChecklistMaquinaEquipModal}
        saving={viewModel.saving}
        loading={viewModel.loading}
        selectedItemChecklistMaquinaEquip={viewModel.selectedItemChecklistMaquinaEquip}
        onClose={viewModel.handleItemChecklistMaquinaEquipModalOpenState}
        onSubmit={viewModel.handleItemChecklistMaquinaEquipSubmit}
      />

      <DeleteDialog
        open={viewModel.itemChecklistMaquinaEquipDeleteModal}
        saving={viewModel.saving}
        title='Você realmente deseja excluir este item?'
        onClose={() => viewModel.handleItemChecklistMaquinaEquipDeleteModalOpenState(null, false)}
        onDelete={viewModel.handleItemChecklistMaquinaEquipDeleteSubmit}
      />

    </>
  );
}


